import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  HttpService,
  PermissionsService,
  ProjectService,
} from "@app/core/services";
import { DesignService } from "@app/core/services/design.service";
import { IconService } from "@app/core/services/icon.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import {
  animate,
  group,
  query,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { LocalStorageService } from "ngx-webstorage";
import { isArray } from "lodash-es";

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss", "./nav-modern.component.scss"],
  animations: [
    trigger("animationForm", [
      state(
        "small",
        style({
          width: "56px",
        })
      ),
      state(
        "big",
        style({
          // Fill available sidebar width in modern layout
          width: "100%",
        })
      ),

      transition("small => big", [
        group([
          query(".title, .icon-expand", style({ opacity: 0 })),
          query(
            ".title, .icon-expand",
            [animate("0.1s", style({ opacity: 1 }))],
            { optional: true }
          ),
          animate("0.23s"),
        ]),
      ]),

      transition("big => small", [
        group([
          query(".title, .icon-expand", style({ opacity: 1 })),
          query(
            ".title, .icon-expand",
            [animate(".1s", style({ opacity: 0 }))],
            { optional: true }
          ),
          animate(".23s"),
        ]),
      ]),
    ]),

    // transition('closedSecondForm => openedSecondForm, closedFirstForm => openedFirstForm', [
    //   animate('0.3s 0.2s')
    // ]),

    // trigger('animationFormTitle', [
    //   state('small', style({
    //     opacity: 0,
    //   })),
    //   state('big', style({
    //     opacity: 1,
    //   })),
    //   transition('small <=> big', [
    //     animate('1.2s')
    //   ]),
    //   // transition('closedSecondForm => openedSecondForm, closedFirstForm => openedFirstForm', [
    //   //   animate('0.3s 0.2s')
    //   // ]),
    // ])
  ],
})
export class NavComponent implements OnInit, AfterViewInit {
  @Input() sizeMenuClass: string;
  @Output() submenuHover = new EventEmitter<{
    header: string;
    children: any[];
    top: number;
  } | null>();

  public menu: any;
  // current design: 'classic' | 'modern'
  public design: "classic" | "modern";
  // Hover handlers for modern collapsed menu popup
  private hoverTimeout: any = null;

  constructor(
    private httpService: HttpService,
    private projectService: ProjectService,
    public ps: PermissionsService,
    private translate: TranslateService,
    private router: Router,
    private storage: LocalStorageService,
    private designService: DesignService,
    private iconService: IconService
  ) {
    this.menu = [
      {
        header: "layouts.navigation.HOME",
        visible: true,
        icon: ["fas", "home"],
        iconName: ["Base", "home"],
        url: ["/", "home"],
      },
      {
        header: "layouts.navigation.EMPLOYEES",
        visible: "TAB_EMPLOYEES_DISPLAY",
        icon: ["fas", "user-friends"],
        iconName: ["Peoples", "peoples"], // icons/Peoples/peoples
        url: ["/", "employees", "users"],
        expanded: false,
      },
      {
        header: "layouts.navigation.STATUS_MCH",
        visible: "TAB_STATUS-MERCH_DISPLAY", //
        icon: ["far", "calendar"],
        iconName: ["Edit", "calendar"], // icons/Edit/calendar
        url: ["/", "status-mch"],
        expanded: false,
      },
      {
        header: "layouts.navigation.POSM",
        visible: "TAB_POSM_DISPLAY",
        icon: ["far", "calendar"],
        iconName: ["Edit", "calendar-success"], // icons/Edit/calendar-success
        url: ["/", "posm"],
        expanded: false,
        children: [
          {
            header: "layouts.navigation.LIBERY",
            visible: "TAB_POSM_LIBRARY_DISPLAY",
            url: ["/", "posm", "library"],
          },
          {
            header: "layouts.navigation.LOADPOSM",
            visible: "BUTTON_POSM_CREATE_DISPLAY",
            url: ["/", "posm", "load"],
          },
          {
            header: "layouts.navigation.LOADORDER",
            visible: "TAB_ORDER_CREATE_DISPLAY",
            url: ["/", "posm", "load-order"],
          },
          {
            header: "layouts.navigation.ORDERS",
            visible: "TAB_ORDER_DISPLAY",
            url: ["/", "posm", "orders"],
          },
          {
            header: "layouts.navigation.LOADADRESS",
            visible: "TAB_POSM_GETFILES_DISPLAY",
            url: ["/", "posm", "load-adress"],
          },
          {
            header: "layouts.navigation.DELIVERIES",
            visible: "TAB_DELIVERY_DISPLAY",
            url: ["/", "posm", "deliveries"],
          },
          {
            header: "layouts.navigation.REESTR_ANKET",
            visible: "TAB_POSM_REESTR_DISPLAY",
            url: ["/", "posm", "reestr-anket"],
          },
        ],
      },
      {
        header: "layouts.navigation.LOGISTIC",
        visible: "TAB_LOGISTIC_DISPLAY",
        icon: ["fas", "map-marker-alt"],
        iconName: ["Edit", "marker-alt"], // src\assets\design-modern\icons\Edit\marker-alt.svg
        url: ["/", "logistic", "merchandisers"],
        expanded: false,
      },
      {
        header: "layouts.navigation.ROUTES",
        visible: "TAB_ROUTES_DISPLAY",
        icon: ["fas", "route"],
        iconName: ["Edit", "routes"], // src\assets\design-modern\icons\Edit\routes.svg
        url: ["/", "routes"],
        expanded: false,
        children: [
          {
            header: "layouts.navigation.ROUTES_ROUTE-PLAN",
            visible: "TAB_ROUTES_ROUTE-PLAN_DISPLAY",
            url: ["/", "routes", "route-plans"],
          },
          {
            header: "layouts.navigation.ROUTES_LOAD-FILES",
            visible: "TAB_ROUTES_LOAD-FILES_DISPLAY",
            url: ["/", "routes", "load-files"],
          },
        ],
      },
      {
        header: "layouts.navigation.MATRIX",
        visible: "TAB_CL_STORES_DISPLAY",
        icon: ["fas", "square"],
        iconName: ["Edit", "matrix"], //src\assets\design-modern\icons\Edit\matrix.svg
        url: ["/", "matrix"],
        expanded: false,
        children: [
          {
            header: "layouts.navigation.MATRIX_STORES",
            visible: "TAB_CL_STORES_DISPLAY",
            url: ["/", "matrix", "stores"],
          },
          {
            header: "layouts.navigation.MATRIX_LOADER",
            visible: "TAB_CL_GETFILES_DISPLAY",
            url: ["/", "matrix", "loader"],
          },
          {
            header: "layouts.navigation.MATRIX_CONTRACT_LIST",
            visible: "TAB_CL_FORMATS_DISPLAY",
            url: ["/", "matrix", "contract-list"],
          },
          {
            header: "layouts.navigation.MATRIX_FORMATS",
            visible: "TAB_CL_FORMATS_DISPLAY",
            url: ["/", "matrix", "formats"],
          },
        ],
      },
      {
        header: "layouts.navigation.BI_REPORTS",
        visible: false,
        icon: ["fas", "chart-pie"],
        iconName: ["Charts", "chart-proportion"], //src\assets\design-modern\icons\Charts\chart-proportion.svg
        url: ["/", "bi-reports"],
      },
      {
        header: "layouts.navigation.STORES",
        visible: "TAB_STORES_DISPLAY",
        icon: ["fas", "store-alt"],
        iconName: ["Build", "application"], //icons/Build/application
        url: ["/", "stores"],
      },
      {
        header: "layouts.navigation.REPORTS",
        visible: "TAB_REPORTS_DISPLAY",
        icon: ["fas", "chart-pie"],
        iconName: ["Charts", "chart-pie"], //icons/Charts/chart-pie
        url: ["/", "reports"],
        expanded: false,
        children: [
          {
            header: "layouts.navigation.REPORTS_PHOTO",
            visible: "TAB_REPORTS_PHOTO_DISPLAY",
            url: ["/", "reports", "photo"],
          },
          {
            header: "layouts.navigation.REPORTS_SERVICE",
            visible: "TAB_REPORTS_SERVICE_DISPLAY",
            url: ["/", "reports", "service"],
          },
          {
            header: "layouts.navigation.REPORTS_EXCEL",
            visible: "TAB_REPORTS_EXCEL_DISPLAY",
            url: ["/", "reports", "excel"],
          },
          {
            header: "layouts.navigation.ORDER",
            visible: "TAB_REPORTS_EXCEL_DISPLAY",
            url: ["/", "reports", "order"],
          },
        ],
      },
      // Раздел Краудсорсинг законсервирован по задаче TASK-1526 (https://ziminatrsuper.atlassian.net/browse/SCRUM-1526)
      // {
      //   header: "layouts.navigation.CROWDSOUNCING",
      //   visible: "TAB_CROWDSOUNCING_DISPLAY",
      //   icon: ["fas", "info-circle"],
      //   iconName: ["Character", "info"], //icons/Character/info
      //   url: ["/", "crowdsourcing"],
      //   expanded: false,
      //   children: [
      //     {
      //       header: "layouts.navigation.LOTS",
      //       visible: "TAB_REPORTS_CROWDSOUNCING_LOTS_DISPLAY",
      //       url: ["/", "crowdsourcing", "lots"],
      //     },
      //     {
      //       header: "layouts.navigation.EMPLOYEERS",
      //       visible: "TAB_CROWDSOUNCING_EMPLOYEERS_DISPLAY",
      //       url: ["/", "crowdsourcing", "employeers"],
      //     },
      //     {
      //       header: "layouts.navigation.DOCUMENTS",
      //       visible: "TAB_CROWDSOUNCING_EMPLOYEERS_DISPLAY",
      //       url: ["/", "crowdsourcing", "documents"],
      //     },
      //     {
      //       header: "layouts.navigation.PAYMENTS",
      //       visible: "TAB_CROWDSOUNCING_PAYMENTS_DISPLAY",
      //       url: ["/", "crowdsourcing", "payments"],
      //     },
      //     {
      //       header: "layouts.navigation.PAYMENTS_CREATE",
      //       visible: "TAB_CROWDSOUNCING_PAYMENTS_CREATE_DISPLAY",
      //       url: ["/", "crowdsourcing", "payments", "create"],
      //     },
      //   ],
      // },
      {
        header: "layouts.navigation.CONSTRUCTOR_PLANOGRAMM",
        visible: false,
        icon: ["fas", "puzzle-piece"],
        iconName: ["Hardware", "hand-painted-plate"], // icons/Hardware/hand-painted-plate
        url: ["/", "constructor"],
      },
      {
        header: "layouts.navigation.VISITS",
        visible: "TAB_VISITS_DISPLAY",
        icon: ["fas", "check-double"],
        iconName: ["Components", "checklist"], //icons/Components/checklist
        url: ["/", "visits"],
      },
      {
        header: "layouts.navigation.MASS_VISITS",
        visible: "TAB_MASSIVE_CHANGES_DISPLAY",
        iconName: ["Arrows", "upload"], //src\assets\design-modern\icons\Arrows\upload.svg
        icon: ["fas", "upload"],
        url: ["/", "mass-visits"],
      },
      {
        header: "layouts.navigation.ADMINISTRATIONS",
        visible: "TAB_ADMINISTRATIONS_DISPLAY",
        icon: ["fas", "user-secret"],
        iconName: ["Peoples", "user-business"], //icons/Peoples/user-business
        url: ["/", "administration"],
        expanded: false,
        children: [
          {
            header: "layouts.navigation.GET_FILES",
            visible: true,
            url: ["/", "administration", "get-files"],
          },
          {
            header: "layouts.navigation.PROJECTS",
            visible: true,
            url: ["/", "administration", "projects"],
          },
          {
            header: "layouts.navigation.APPLICATIONS",
            visible: true,
            url: ["/", "administration", "applications"],
          },
          {
            header: "layouts.navigation.STATUS",
            visible: true,
            url: ["/", "administration", "status"],
          },
          {
            header: "layouts.navigation.SMS",
            visible: true,
            url: ["/", "administration", "sms"],
          },
          {
            header: "layouts.navigation.JIRA_TASK_TIME_REPORT",
            visible: true,
            url: ["/", "administration", "jira-task-time-report"],
          },
          {
            header: "layouts.navigation.MATERIALS",
            visible: true,
            url: ["/", "administration", "materials"],
          },
        ],
      },
      {
        header: "layouts.navigation.CAP",
        visible: "TAB_CAP_DISPLAY",
        icon: ["fas", "copyright"],
        iconName: ["Arrows", "upload-one"], // icons/Arrows/upload-one
        url: ["/", "cap", "main"],
      },
      {
        header: "layouts.navigation.PROMO",
        visible: ["TAB_OREH-PROMO_DISPLAY", "TAB_DONON-PROMO_DISPLAY"],
        icon: ["far", "check-circle"],
        iconName: ["Money", "insert-card"], //icons/Money/insert-card
        url: ["/", "other", "promo"],
      },
      {
        header: "layouts.navigation.EQUIPMENT",
        visible: "TAB_EQUIPMENT_REQUESTS_DISPLAY",
        icon: ["fas", "tools"],
        iconName: ["Industry", "spanner"], //icons/Industry/spanner
        url: ["/", "other"],
        expanded: false,
        children: [
          {
            header: "layouts.navigation.EQUIPMENT_REQUESTS",
            visible: "TAB_EQUIPMENT_REQUESTS_LIST_DISPLAY",
            url: ["/", "requests", "main"],
          },
          {
            header: "layouts.navigation.EQUIPMENT_REQUESTS_UPLOAD",
            visible: "TAB_EQUIPMENT_REQUESTS_UPLOAD_DISPLAY",
            url: ["/", "requests", "upload"],
          },
          {
            header: "layouts.navigation.REQUEST",
            visible: "TAB_EQUIPMENT_REQUESTS_REQUEST_DISPLAY",
            url: ["/", "other", "request"],
          },
          {
            header: "layouts.navigation.EQUIPMENTS",
            visible: "TAB_EQUIPMENT_REQUESTS_EQUIPMENTS_DISPLAY",
            url: ["/", "equipments", "main"],
          },
          {
            header: "layouts.navigation.EQUIPMENTS_DIRECTORY-AP",
            visible: "TAB_EQUIPMENT_REQUESTS_ADDRESS_PROGRAMM_DISPLAY",
            url: ["/", "equipments", "directory-ap"],
          },
        ],
      },
      {
        header: "layouts.navigation.FILEHOSTING",
        visible: "TAB_FILEHOSTING_DISPLAY",
        icon: ["fas", "folder-open"],
        iconName: ["Office", "folder-open"], //icons/Office/folder-open
        url: ["/", "filehosting"],
      },
    ];
    // initialize design
    this.design = this.designService.getDesign();
    // Preload icons early for modern design
    if (this.design === "modern") {
      this.preloadMenuIcons();
    }
  }

  ngOnInit() {}

  // subscribe to design changes
  ngAfterViewInit() {
    this.designService.design$.subscribe((d) => {
      this.design = d;
      if (d === "modern") this.preloadMenuIcons();
    });
  }

  getVisibleMenu(array) {
    return array.filter((el) => this.has(el.visible) === true);
  }

  expand(m, event) {
    m.expanded = !m.expanded;
  }

  logout() {
    this.storage.clear("access_token");
    //localStorage.clear();
    this.router.navigate(["/auth/login"]);
  }

  has(permission: string | string[] | boolean) {
    if (typeof permission === "boolean") return permission;
    if (isArray(permission))
      return permission.some((p) => {
        return this.ps.has(p);
      });
    return this.ps.hasNav(permission);
  }

  // Public method to cancel hover timeout (called from body component)
  cancelHoverTimeout() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  onMenuItemHover(menuItem: any, event: MouseEvent) {
    // Only emit for modern design in collapsed mode with children
    if (
      this.design === "modern" &&
      this.sizeMenuClass === "small" &&
      menuItem.children?.length
    ) {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
      const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
      this.submenuHover.emit({
        header: menuItem.header,
        children: this.getVisibleMenu(menuItem.children),
        top: rect.top,
      });
    }
  }

  onMenuItemLeave() {
    if (this.design === "modern" && this.sizeMenuClass === "small") {
      this.hoverTimeout = setTimeout(() => {
        this.submenuHover.emit(null);
      }, 400); // longer delay for mouse to reach popup
    }
  }

  private preloadMenuIcons() {
    try {
      const items: string[][] = [];
      const collect = (arr: any[]) => {
        arr.forEach((m) => {
          if (m.iconName && Array.isArray(m.iconName)) items.push(m.iconName);
          if (m.children) collect(m.children);
        });
      };
      collect(this.getVisibleMenu(this.menu));
      this.iconService.preloadByParts(items);
    } catch {}
  }
}
